var map = {
	"./centremultiprofessionnelmonteregien.jpg": "7b12",
	"./coref.jpg": "0e43",
	"./pret-royal.jpg": "cd34",
	"./project-example-1.jpg": "727e",
	"./yorkie-et-compagnons.jpg": "16f2",
	"./yorkiecam.jpg": "00cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35ef";